import { apiGet, apiPost, apiPut } from "./api";

export type PromptVersion = { id: string; saved_at: string; note?: string; char_count?: number };

/** The master prompt or one synthesis template, as the prompt editors show it. */
export type SynthesisPromptTemplate = {
  kind: string;
  label: string;
  help: string;
  content: string;
  /** Placeholders a save must keep (the server refuses a save without them). */
  required: string[];
  uses_workspace_copy: boolean;
  versions: PromptVersion[];
};

export type SynthesisPromptPreview = {
  system: string;
  new_project: string;
  update: string;
  profile: string;
  pdr_reference_chars: number;
};

type TemplatesResponse = { templates: SynthesisPromptTemplate[] };

export async function fetchSynthesisPrompts(): Promise<SynthesisPromptTemplate[]> {
  return (await apiGet<TemplatesResponse>("/api/synthesis-prompts")).templates;
}

export async function saveSynthesisPrompt(
  kind: string,
  content: string,
  note = "",
): Promise<SynthesisPromptTemplate[]> {
  return (
    await apiPut<TemplatesResponse>(`/api/synthesis-prompts/${encodeURIComponent(kind)}`, {
      content,
      note,
    })
  ).templates;
}

export async function rollbackSynthesisPrompt(versionId: string): Promise<SynthesisPromptTemplate[]> {
  return (
    await apiPost<TemplatesResponse>("/api/synthesis-prompts/rollback", { version_id: versionId })
  ).templates;
}

export async function previewSynthesisPrompt(body: {
  target_company: string;
  prompts: Record<string, string>;
  pdr_schema_profile?: string;
}): Promise<SynthesisPromptPreview> {
  return apiPost<SynthesisPromptPreview>("/api/synthesis-prompts/preview", body);
}

export function missingTokens(text: string, required: string[]): string[] {
  return required.filter((token) => !text.includes(token));
}
